import React from 'react';
import DataTableCard from '../../../../components/ui/DataTableCard';
import { useFetchList } from '../../../../hooks/useFetchList';
import { dateTimeBody, easipolStatusBodyTemplate, paymentStatusBodyTemplate } from '../../../../utils/tableTemplates';

const COLUMNS = [
    {field: 'id', header: 'ID'},
    {field: 'policyNumber', header: 'Policy Number'},
    {field: 'productName', header: 'Product Name'},
    {field: 'payerName', header: 'Payer Name'},
    {field: 'billingAddress', header: 'Billing Address'},
    {field: 'mobileNumber', header: 'Phone Number'},
    {field: 'emailAddress', header: 'Email'},
    {field: 'amount', header: 'Amount'},
    {field: 'paymentStatus', header: 'Payment Status', body: paymentStatusBodyTemplate},
    {field: 'paymentReference', header: 'Payment Reference'},
    {field: 'notes', header: 'Payment Notess'},
    {field: 'easipolPaymentResponse', header: 'Easipol Payment Status', body: easipolStatusBodyTemplate},
    {field: 'pollUrl', header: 'Paynow Verification Link'},
    {field: 'timeStamp', header: 'Timestamp', body: dateTimeBody('timeStamp')}
];

const PaymentsReportTable = () => {
    const {rows} = useFetchList('payment/report');

    return (
        <DataTableCard
            title="Payments Report"
            exportName="Payments"
            columns={COLUMNS}
            rows={rows}
            emptyMessage="No payments found"
        />
    );
};

export default PaymentsReportTable;
